import { z } from 'zod';
import { AccountType, Platform } from '../enums';

export const clientPlatformSchema = z.object({
  id: z.string(),
  platform: z.nativeEnum(Platform),
  accountType: z.nativeEnum(AccountType).default(AccountType.ORGANIC),
  enabled: z.boolean(),
  auth: z.record(z.string(), z.unknown()).nullable().optional(),
  clientId: z.string().uuid(),
  dummy: z.boolean().default(false).optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ClientPlatformSchema = z.infer<typeof clientPlatformSchema>;

export const instagramAccountListItemSchema = z.object({
  igId: z.string(),
  fbId: z.string(),
  fbConnectedId: z.string(),
  displayName: z.string(),
  profilePictureUrl: z.string().nullable().optional(),
});

export type InstagramAccountListItem = z.infer<typeof instagramAccountListItemSchema>;
